import * as actionTypes from './actionTypes'

export function startResizeWindow(isResizingStateLocation) {
    return {
        type: actionTypes.START_RESIZE_WINDOW,
        payload : {
            isResizingStateLocation
        }
    }
}

export function endResizeWindow(
    isResizingStateLocation, 
    sizeStateLocation, 
    curSize, 
    positionLocation, 
    position) {
    
    return {
        type: actionTypes.END_RESIZE_WINDOW,
        payload: {
            isResizingStateLocation,
            positionLocation,
            size: curSize,
            sizeStateLocation,
            position
        }
    }
}

export function setWindowSize(size, sizeStateLoc) {
	return {
		type: actionTypes.SET_WINDOW_SIZE,
		payload: {
			size,
			sizeStateLoc
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-resize/src/actions/actions.js